<template>
  <div class="app-container">
    <div class="wt-form-tablelist-container integral-points" v-loading="loadingFlag">
      <el-tabs v-model="activeTabName" @tab-click="tabChange">
        <el-tab-pane label="每日积分项设置" name="1"></el-tab-pane>
        <el-tab-pane label="积分项设置" name="2"></el-tab-pane>
      </el-tabs>
      <div v-if="activeTabName === '1'">
        <normal-table :params="firstForm" :data="firstData">
          <template slot="tableListButtonsAfter" slot-scope="data">
            <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_INTEGRALPOINTS:EDIT'">
              <el-button size="mini" type="primary" style="background-color: transparent; color: #409EFF; border: 0;font-weight: bolder;" @click="toClickAction(data.row)">编辑</el-button>
            </wt-auth>
          </template>
        </normal-table>
      </div>
      <div v-if="activeTabName === '2'">
        <normal-table :params="secondForm" :data="secondData">
          <template slot="tableListButtonsAfter" slot-scope="data">
            <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_INTEGRALPOINTS:EDIT'">
              <el-button size="mini" type="primary" style="background-color: transparent; color: #409EFF; border: 0;font-weight: bolder;" @click="toClickAction(data.row)">编辑</el-button>
            </wt-auth>
          </template>
        </normal-table>
      </div>
    </div>
    <wt-detail-page  :visible.sync="firstObj.visible" :component-name="firstObj.componentName" component-type="edit" />
    <wt-detail-page  :visible.sync="secondObj.visible" :component-name="secondObj.componentName" component-type="edit" />
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      activeTabName: '1',
      loadingFlag: false,
      firstForm: { //  表单数据
        fields: [
          { label: '标题', value: 'name' },
          { label: '积分/次', value: 'rewardIntegral' },
          { label: '每日上限次数', value: 'times' }
        ],
        attr: {
          maxHeight: 'auto',
          index: true
        }
      },
      firstData: [],
      secondForm: { //  表单数据
        fields: [
          { label: '标题', value: 'name' },
          { label: '积分', value: 'rewardIntegral' }
        ],
        attr: {
          maxHeight: 'auto',
          index: true
        }
      },
      secondData: [],
      firstObj: {
        visible: false,
        componentName: 'IntegralPointsDayEdit'
      },
      secondObj: {
        visible: false,
        componentName: 'IntegralPointsEdit'
      }
    }
  },
  created() {
    this.requestTableData(this.activeTabName)
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    toClickAction(row) {
      this.$store.dispatch('setIntegralRulesDetailData', row)
      if (this.activeTabName === '1') {
        this.firstObj.visible = true
      }
      if (this.activeTabName === '2') {
        this.secondObj.visible = true
      }
    },
    tabChange() {
      this.requestTableData(this.activeTabName)
    },
    requestTableData(rulesType) {
      this.loadingFlag = true
      request({
        url: '/modules/integralRules/integralRulesList',
        method: 'post',
        data: { rulesType: rulesType }
      }).then(res => {
        this.loadingFlag = false
        if (res.code === '0') {
          if (rulesType === '1') {
            this.firstData = res.data
          }
          if (rulesType === '2') {
            this.secondData = res.data
          }
        }
      })
    }
  },
  watch: {
    firstObj: {
      handler(val) {
        if (!val.visible) {
          this.tabChange()
        }
      },
      deep: true
    },
    secondObj: {
      handler(val) {
        if (!val.visible) {
          this.tabChange()
        }
      },
      deep: true
    }
  }
}
</script>
<style>
.integral-points {
  padding: 20px;
}
</style>
